import { createContext, useContext, useMemo, useState } from 'react'
import { ProfilesPsyAliveCards } from '../types'
import { ProfessionalsPsyAliveContextProps } from './types'
import { FunctionComponentChildren } from '@/@types/react'

const PsyAliveContext = createContext<ProfessionalsPsyAliveContextProps>(null)

export const ProfessionalPsyAliveProvider: FunctionComponentChildren = ({
  children,
}) => {
  const [professionalsPsyAlive, setProfessionalsPsyAlive] = useState<
    ProfilesPsyAliveCards[]
  >([])

  const values = useMemo(
    () => ({ professionalsPsyAlive, setProfessionalsPsyAlive }),
    [professionalsPsyAlive, setProfessionalsPsyAlive],
  )

  return (
    <PsyAliveContext.Provider value={values}>
      {children}
    </PsyAliveContext.Provider>
  )
}

export const usePsyAliveContext = () => {
  const context = useContext(PsyAliveContext)

  if (!context) {
    throw new Error(
      'usePsyAliveContext must be used within a ProfessionalProvider',
    )
  }

  return context
}
